var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("供应系统")]),
            _c("el-breadcrumb-item", [_vm._v("商品管理")]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { name: "dishesManagement" } } },
              [_vm._v("菜品管理")]
            ),
            _c("el-breadcrumb-item", [_vm._v("新增菜品")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-form",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.formLoading,
                expression: "formLoading",
              },
            ],
            ref: "commodityForm",
            attrs: {
              model: _vm.listParams,
              rules: _vm.checkListParams,
              "label-width": "150px",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "商品分类：",
                          prop: "plaGoodCategoryId",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "300px" },
                            attrs: {
                              clearable: "",
                              size: "small",
                              placeholder: "请选择商品分类",
                            },
                            model: {
                              value: _vm.listParams.plaGoodCategoryId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.listParams,
                                  "plaGoodCategoryId",
                                  $$v
                                )
                              },
                              expression: "listParams.plaGoodCategoryId",
                            },
                          },
                          _vm._l(_vm.categoryNameList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.title, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品名称：", prop: "title" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            size: "small",
                            placeholder: "请输入商品别名",
                          },
                          model: {
                            value: _vm.listParams.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.listParams, "title", $$v)
                            },
                            expression: "listParams.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品别名：", prop: "alias" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            size: "small",
                            placeholder: "请输入商品别名",
                          },
                          model: {
                            value: _vm.listParams.alias,
                            callback: function ($$v) {
                              _vm.$set(_vm.listParams, "alias", $$v)
                            },
                            expression: "listParams.alias",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品规格：", prop: "plaGoodSpecId" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "300px" },
                            attrs: {
                              clearable: "",
                              size: "small",
                              placeholder: "请选择商品规格",
                            },
                            model: {
                              value: _vm.listParams.plaGoodSpecId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "plaGoodSpecId", $$v)
                              },
                              expression: "listParams.plaGoodSpecId",
                            },
                          },
                          _vm._l(_vm.commoditySpecList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.title, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "最小重量：", prop: "minWeight" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            size: "small",
                            placeholder: "请输入商品最小重量",
                          },
                          model: {
                            value: _vm.listParams.minWeight,
                            callback: function ($$v) {
                              _vm.$set(_vm.listParams, "minWeight", $$v)
                            },
                            expression: "listParams.minWeight",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "最大重量：", prop: "maxWeight" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            size: "small",
                            placeholder: "请输入商品最大重量",
                          },
                          model: {
                            value: _vm.listParams.maxWeight,
                            callback: function ($$v) {
                              _vm.$set(_vm.listParams, "maxWeight", $$v)
                            },
                            expression: "listParams.maxWeight",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品图片：", prop: "picture" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upload-thumbnail-img",
                            attrs: { loading: _vm.uploading },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-circle-plus-outline upload-icon",
                            }),
                            _c("input", {
                              staticClass: "hidden-upload",
                              attrs: { type: "file", id: "uploadDom" },
                              on: { change: _vm.doUpload },
                            }),
                          ]
                        ),
                        _vm.listParams.picture.length > 0
                          ? _c(
                              "div",
                              { staticClass: "wrap-thumbnail-img" },
                              _vm._l(
                                _vm.listParams.picture,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "thumbnail-img",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "combined-img" },
                                        [
                                          _c("img", {
                                            key: index,
                                            staticClass:
                                              "thumbnail-img-wrapped",
                                            attrs: { src: item, alt: "" },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "hover-img" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-delete el-icon-circle-close-outline close-btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteImg(index)
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                !this.$route.query.id
                  ? _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "商品价格：",
                              "label-width": "350px",
                              prop: "price",
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  size: "small",
                                  placeholder: "请输入商品价格",
                                },
                                on: { change: _vm.resetPrice },
                                model: {
                                  value: _vm.listParams.price,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listParams, "price", $$v)
                                  },
                                  expression: "listParams.price",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._l(
                          _vm.listParams.goodLevelPrices,
                          function (item, index) {
                            return _c(
                              "el-form-item",
                              {
                                key: item.id,
                                attrs: {
                                  prop: `goodLevelPrices[${index}].levelPrice`,
                                  label: `${item.levelName}-商品价格：`,
                                  "label-width": "350px",
                                  rules: [
                                    {
                                      required: true,
                                      message: "请填写该商品价格",
                                      trigger: `blur`,
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      size: "small",
                                      disabled: !_vm.listParams.price,
                                      placeholder: `请输入${item.levelName}的商品价格`,
                                    },
                                    model: {
                                      value: item.levelPrice,
                                      callback: function ($$v) {
                                        _vm.$set(item, "levelPrice", $$v)
                                      },
                                      expression: "item.levelPrice",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.listParams.supplyId === "3"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "京东参考价", prop: "referencePrice" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticStyle: { width: "300px" },
                        attrs: { size: "small", placeholder: "请输入参考价格" },
                        model: {
                          value: _vm.listParams.referencePrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "referencePrice", $$v)
                          },
                          expression: "listParams.referencePrice",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("元")])],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              { attrs: { label: "限购规则：", prop: "supplyRuleIds" } },
              [
                _c(
                  "el-checkbox-group",
                  {
                    on: { change: _vm.changeSupplyRuleIds },
                    model: {
                      value: _vm.listParams.supplyRuleIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "supplyRuleIds", $$v)
                      },
                      expression: "listParams.supplyRuleIds",
                    },
                  },
                  _vm._l(_vm.restrictionRuleList, function (item) {
                    return _c(
                      "el-checkbox",
                      { key: item.id, attrs: { label: item.id } },
                      [_vm._v(_vm._s(item.title))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-collapse",
              {
                attrs: { accordion: "" },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              _vm._l(_vm.listParams.goodFarmSites, function (item, index) {
                return _c(
                  "el-collapse-item",
                  { key: item.value, attrs: { name: index } },
                  [
                    _vm._v(" " + _vm._s(item.id) + " "),
                    _c(
                      "template",
                      { slot: "title" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: `基地${index + 1}：`,
                              "label-width": "100px",
                              prop: `goodFarmSites[${index}].farmId`,
                              rules: {
                                required: true,
                                message: "请选择基地",
                                trigger: `blur`,
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  size: "small",
                                  clearable: "",
                                  disabled: Boolean(
                                    _vm.listParams.goodFarmSites[index].farmId
                                  ),
                                  placeholder: "请选择基地",
                                },
                                model: {
                                  value: item.farmId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "farmId", $$v)
                                  },
                                  expression: "item.farmId",
                                },
                              },
                              _vm._l(_vm.allbase, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.lable,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                            _c("i", {
                              staticClass: "el-icon-circle-plus add",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.add(1)
                                },
                              },
                            }),
                            _vm.listParams.goodFarmSites.length > 1
                              ? _c("i", {
                                  staticClass: "el-icon-remove reduce",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.reduce(1, index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "border" },
                      _vm._l(
                        _vm.listParams.goodFarmSites[index].siteStockProportion,
                        function (item, indexs) {
                          return _c(
                            "div",
                            { key: item.value, staticClass: "flex" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    "label-width": "30px",
                                    prop: `goodFarmSites[${index}].siteStockProportion[${indexs}].siteId`,
                                    rules: [
                                      {
                                        required: true,
                                        message: "请选择供应点",
                                        trigger: `blur`,
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        clearable: "",
                                        placeholder: "请选择供应点",
                                        disabled: Boolean(
                                          _vm.listParams.goodFarmSites[index]
                                            .siteStockProportion[indexs].siteId
                                        ),
                                      },
                                      model: {
                                        value: item.siteId,
                                        callback: function ($$v) {
                                          _vm.$set(item, "siteId", $$v)
                                        },
                                        expression: "item.siteId",
                                      },
                                    },
                                    _vm._l(_vm.allSupplyLsit, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.lable,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    "label-width": "30px",
                                    prop: `goodFarmSites[${index}].siteStockProportion[${indexs}].stockProportion`,
                                    rules: [
                                      {
                                        required: true,
                                        message: "请输入比例",
                                        trigger: `blur`,
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: { size: "mini" },
                                    model: {
                                      value: item.stockProportion,
                                      callback: function ($$v) {
                                        _vm.$set(item, "stockProportion", $$v)
                                      },
                                      expression: "item.stockProportion",
                                    },
                                  }),
                                  _vm._v("% "),
                                  _c("i", {
                                    staticClass: "el-icon-circle-plus add",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.add(2, index)
                                      },
                                    },
                                  }),
                                  _vm.listParams.goodFarmSites[index]
                                    .siteStockProportion.length > 1
                                    ? _c("i", {
                                        staticClass: "el-icon-remove reduce",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.reduce(2, index, indexs)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                  ],
                  2
                )
              }),
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "商品详情：",
                  prop: "description",
                  "label-width": "150px",
                },
              },
              [
                _c("RichTextarea", {
                  staticClass: "wang-editor-style",
                  attrs: { height: "450px" },
                  model: {
                    value: _vm.listParams.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.listParams, "description", $$v)
                    },
                    expression: "listParams.description",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "align-center",
                staticStyle: { "margin-top": "100px" },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.isDisabled,
                      size: "small",
                      type: "primary",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.saveAdd("commodityForm")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "mgl20",
                    attrs: { size: "small" },
                    on: { click: _vm.backToList },
                  },
                  [_vm._v("返回")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }